module.exports = __webpack_public_path__ + "img/bg-3.d1aefd2b.jpg";